
/**
 * Formate un montant avec séparateur de milliers français
 * @param {number} amount - Montant à formater
 * @returns {string} Montant formaté
 */

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XAF'
    }).format(amount);
};

  /**
 * Formate un montant en devise
 * @param {number} amount - Montant à formater
 * @returns {string} Montant formaté
 */
export const formatCurrencys = (amount) => {
  if (!amount && amount !== 0) return "0 Fcfa";
  
  return new Intl.NumberFormat("fr-FR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(amount) + " Fcfa";
};

/**
 * Calcule le total TTC d'une facturation
 * @param {Object} facturation - Données de la facturation
 * @returns {number} Total TTC
 */
export const calculateTotalTTC = (facturation) => {
  if (!facturation) return 0;
  return facturation.totalAuc * (facturation.commissions / 100);
};

/**
 * Détermine l'état et les actions possibles d'une facturation
 * @param {Object} facturation - Données de la facturation
 * @returns {Object} État et permissions
 */
export const getFacturationState = (facturation) => {
  const isDraft = facturation.facturationStatut === 0;
  const isValidated = facturation.facturationStatut === 1;
  const isPaid = facturation.hasPaid;
  const isFinalPaid = facturation.commissionPaid; // Nouveau statut de paiement final

  return {
    isDraft,
    isValidated,
    isPaid,
    isFinalPaid,
    canValidate: isDraft && !isValidated,
    canPayCommission: isValidated && !isFinalPaid && !isPaid,
    canFinalPay: isValidated && isFinalPaid && !isPaid,
    canViewOnly: isPaid,
    canDelete: isDraft && !isValidated
  };
};


/**
 * Gère les erreurs API de façon uniforme
 * @param {Error} error - Erreur à traiter
 * @returns {string} Message d'erreur utilisateur
 */
export const handleApiError = (error) => {
  // console.error('API Error:', error);
  
  if (error.response?.data?.message) {
    return error.response.data.details;
  }
  
  if (error.message?.includes('Network Error')) {
    return "Erreur de connexion. Vérifiez votre internet.";
  }
  
  return "Une erreur inattendue est survenue. Veuillez réessayer.";
};